import { render, staticRenderFns } from "./BrandAssetsProvider.vue?vue&type=template&id=4563dbc2&"
import script from "./BrandAssetsProvider.vue?vue&type=script&lang=js&"
export * from "./BrandAssetsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports